import styled from 'styled-components';

export const ChatContainer = styled.div`
	width: 300px;
  transition-property: all;
  transition-duration: .8s;
	&.Chat-Element-Expand {
	  width: 500px;
	}
	&.Chat-Element-Closed {
	  width: 200px;
	}
`;

export const WrapperChatHeader = styled.div`
  background: ${props => props.backgroundColor};
  color: white;
  display: flex;
  padding: 7px 15px;
  flex-direction: row;
  align-items: center;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  -webkit-border-top-left-radius: 3px;
  -webkit-border-top-right-radius: 3px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  .Icon {
    margin-left: 10px;
  }
`;

export const ContainerChatHeader = styled.div`
  flex: 1;
  max-width: calc(100% - ${props => props.maxWidth}px);
  .Icon {
    margin-left: 0;
    margin-right: 10px;
  }
`;

export const ChatMemberListHeader = styled.div`
  color: ${props => props.textColor};
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  span {
    flex: 1;
  }
`;

export const MemberListContainer = styled.div`
  border-right: 1px solid;
  border-color: ${props => props.borderColor};
  padding: 15px;
  position: absolute;
  z-index: 1000;
  background: white;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 180px;
	transition-property: all;
	transition-duration: .8s;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	&.Closed {
	  width: 0;
    padding: 15px 0;
	}
`;

export const WrapperContainerMessageList = styled.div`
  &.Chat-Element-Expand {
    height: 550px;
  }
`;

export const WrapperContainerMessage = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex: 1;
  position: relative;
`;

export const ContainerMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1;
  max-width: 100%;
`;

export const WrapperListOptions = styled.div`
  z-index: 100;
  position: relative;
  font-size: 0.8em;
`;

export const OptionList = styled.div`
  padding: 5px 15px;
  border-bottom: 1px solid;
  border-color: ${props => props.borderColor};
  &:last-child {
    border: none;
  }
  ul {
    li {
      white-space: nowrap;
      line-height: 25px;
      width: 100px;
      cursor: pointer;
      font-size: 1.1em;
    }
  }
`;